import { inject } from '@angular/core';

import { AlertsFacade } from 'app/alerts/facades/alerts.facade';
import { isBrokenSensorsAlert } from 'app/alerts/triggerStateMapping';
import { DeviceId } from 'app/site-detail/models/Device';

export function useResolveBrokenSensorsAlert() {
    const alertsFacade = inject(AlertsFacade);

    const resolve = async (deviceId: DeviceId): Promise<void> => {
        const alert = alertsFacade.getAlertsByDevice(deviceId).find(isBrokenSensorsAlert);
        if (!alert) return;

        await alertsFacade.resolve(alert.id);
    };

    return { resolve };
}
